import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { UntypedFormControl, Validators } from '@angular/forms';
import { BpService } from '../../../../core/services/bp.service';
import { ValidationService } from '../../../../shared/components/form-controls/validators/validation.service';
import {
  RegisterEntrepreneurFields, RegisterEntrepreneurForm,
  RegisterOrganisationFields,
  RegisterOrganisationForm,
} from './register-organization.model';
import { OrganisationType } from '../../../../core/models/organisation.model';
import { AuthApiService } from '../../../../core/modules/auth/auth-api.service';

@Component({
  selector: 'tax-register-organization',
  templateUrl: './register-organization.component.html',
  styleUrls: ['./register-organization.component.sass'],
})
export class RegisterOrganizationComponent implements OnInit, OnDestroy {
  readonly organisationType = OrganisationType;

  organization?: RegisterOrganisationFields | RegisterEntrepreneurFields;
  password: UntypedFormControl = new UntypedFormControl('', [Validators.required, this.validationService.isPasswordStrength.bind(this)]);
  passwordConfirmation: UntypedFormControl = new UntypedFormControl('', [Validators.required, this.validationService.isEqual.bind(this, this.password)]);
  showSuccessWindow = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private bpService: BpService,
    private router: Router,
    private validationService: ValidationService,
    private authApiService: AuthApiService,
  ) { }

  ngOnInit(): void {
    this.getOrganizationFormData();
    this.runIsEqualValidatorOnPasswordChange();

    this.password.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((password: string) => {
        if (this.organization) {
          this.organization.password = password;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  goBack(): void {
    this.router.navigate(['landing/registration/select-eds']);
  }

  loginToCabinet(organization: RegisterOrganisationFields | RegisterEntrepreneurFields): void {
    this.authApiService.singIn({
      login: organization.rootLogin,
      secret: organization.password,
      rememberMe: false,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.router.navigate(['main/kkms']);
      });
  }

  submitForm(organization: RegisterOrganisationFields | RegisterEntrepreneurFields): void {
    this.bpService.submitCurrentBp(organization)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSuccessWindow = true;
      });
  }

  private getOrganizationFormData(): void {
    this.bpService.getCurrentBpFormData<RegisterOrganisationForm | RegisterEntrepreneurForm>()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.organization = response.fields;
      });
  }

  private runIsEqualValidatorOnPasswordChange(): void {
    this.password.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.passwordConfirmation.updateValueAndValidity());
  }
}
